import { createColumnHelper } from '@tanstack/react-table'
import dayjs from 'dayjs'
import { useState } from 'react'

import { TableComponent, commonAccessorColumn } from '../../../components/table'
import { SbpPayment, SbpRefundOperation } from '../../../types.ts'
import { FetchErrorMessage, SbpPaymentStatus } from '../../../components'
import { useGetReverseList } from '../../../services'

import { RefundOperationView } from './refund-operation-view.tsx'

const columnHelper = createColumnHelper<SbpRefundOperation>()
const refundOperationCols = [
  columnHelper.accessor('operationId', commonAccessorColumn('Номер операции')),
  columnHelper.accessor('createTime', {
    header: 'Дата и время',
    enableSorting: false,
    cell: (props) => dayjs(props.getValue()).utc(false).format('DD.MM.YYYY HH:mm'),
  }),
  columnHelper.accessor('sndPam', commonAccessorColumn('ФИО клиента')),
  columnHelper.accessor('sndPhone', commonAccessorColumn('Телефон клиента')),
  columnHelper.accessor('state', {
    header: 'Статус',
    enableSorting: false,
    cell: (props) => <SbpPaymentStatus state={props.getValue()} type={props.row.original.type} />,
  }),
  columnHelper.accessor('amount', {
    header: 'Сумма',
    enableSorting: false,
    cell: (props) =>
      props.getValue()?.toLocaleString('ru-RU', { style: 'currency', currency: props.row.original.cur ?? 'RUB' }),
  }),
]

export const RefundOperationsTab = ({ payment }: { payment: SbpPayment }): React.ReactElement => {
  const [activeItem, setActiveItem] = useState<SbpRefundOperation | null>(null)
  const { data, isLoading, isError, refetch, isRefetching } = useGetReverseList(payment)

  const handleViewRefund = (item: SbpRefundOperation | null) => () => setActiveItem(item)

  return (
    <FetchErrorMessage isFetching={isRefetching} refetch={refetch} isError={isError}>
      {activeItem ? (
        <RefundOperationView refund={activeItem} handleBack={handleViewRefund(null)} />
      ) : (
        <TableComponent<SbpRefundOperation>
          rowKey="operationId"
          data={data?.data ?? []}
          isLoading={isLoading}
          columns={refundOperationCols}
          onRowClick={handleViewRefund}
        />
      )}
    </FetchErrorMessage>
  )
}
